<template>
  <div class="app-main-inner">
    <el-dialog
      :visible="visible"
      :title="title"
      width="1050px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="5vh"
      custom-class="cooperate-branch-popup"
      @open="showDialog"
    >
      <el-form :inline="true" label-width="60px" label-position="left" style="margin-top: 4px;">
        <div v-show="!showCooperateAll" class="app-main-inner-row" style="padding: 0;">
          <el-form-item>
            <el-button v-show="orderCenterBranch || hasOpOfficeCooperate" type="primary" no="add" :style="{width: $selectByLang('65px', '65px', '65px', '110px', '65px', '65px')}" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button v-show="orderCenterBranch" type="primary" no="edit" :style="{width: $selectByLang('65px', '65px', '65px', '110px', '90px', '90px')}" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-show="orderCenterBranch" type="danger" no="delete" style="width: 65px;" @click="deleteHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-button v-show="!orderCenterBranch" type="primary" no="businessStatus" style="width: 65px;" @click="updateStateHandler(2)">{{ $t('CargoMsg.Cargo_BusinessStatus') }}</el-button>
            <el-button v-show="!orderCenterBranch" type="primary" no="chargeStatus" style="width: 65px;" @click="updateStateHandler(3)">{{ $t('CargoMsg.Cargo_ChargeStatus') }}</el-button>
            <el-dropdown
              split-button
              type="primary"
              style="padding-left: 5px;"
              @click="btnStatusLogHandler()"
              @command="p=>{commandCode=p;btnStatusLogHandler()}"
            >
              {{ commandCode }}
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="$t('CargoMsg.Cargo_CooperateStatusLog')" no="cooperateStatusLog">{{ $t('CargoMsg.Cargo_CooperateStatusLog') }}
                </el-dropdown-item>
                <el-dropdown-item :command="$t('CargoMsg.Cargo_BusinessStatusLog')" no="businessStatusLog">{{ $t('CargoMsg.Cargo_BusinessStatusLog') }}
                </el-dropdown-item>
                <el-dropdown-item :command="$t('CargoMsg.Cargo_ChargeStatusLog')" no="chargeStatusLog">{{ $t('CargoMsg.Cargo_ChargeStatusLog') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="primary" style="width: 65px;margin-left: 5px;" @click="refreshHandler">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
            <el-button v-show="orderCenterBranch" type="primary" no="profitShareAdjust" :style="{width: $selectByLang('65px', '65px', '65px', '165px', '165px', '150px')}" @click="profitShareAdjustHandler">{{ $t('CargoMsg.Cargo_ProfitShareAdjust') }}</el-button>
          </el-form-item>
        </div>
        <div class="app-main-inner-row row-grid" style="min-height: 320px;padding: 0;">
          <cargo-ag-grid
            config-module="101355"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :style="{width:'610px',height:'321px'}"
          />
        </div>
      </el-form>
      <div slot="footer" style="height: 25px;">
        <span style="position: absolute; right: 0; padding-right: 10px;">
          <el-button v-show="controlConfirmButton || hasOpOfficeCooperate" type="primary" no="confirm" @click="onOK">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button v-show="controlConfirmButton || hasOpOfficeCooperate" style="width: 65px;margin-left: 5px;" no="cancel" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          <el-button v-show="!controlConfirmButton && !hasOpOfficeCooperate" type="primary" no="close" @click="onCancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 新增/编辑 -->
    <cooperation-branch-dialog
      v-if="cooperationBranchDialog.visible"
      :visible.sync="cooperationBranchDialog.visible"
      :job-uuid="cooperationBranchDialog.jobUuid"
      :cooperate="cooperationBranchDialog.cooperate"
      :submit-call-back="cooperationBranchDialog.submitCallBack"
      :editable="cooperationBranchDialog.editable"
      :action-desc="cooperationBranchDialog.actionDesc"
      :rows="rowData"
      :op-office="job.opOffice"
    />
    <!-- 更新业务/费用状态 -->
    <cooperate-status-dialog
      v-if="cooperateStatusDialog.visible"
      :visible.sync="cooperateStatusDialog.visible"
      :status-type-desc="cooperateStatusDialog.statusTypeDesc"
      :update-state-call-back="cooperateStatusDialog.updateStateCallBack"
    />
    <!-- 日志记录 -->
    <cooperate-status-log-dialog
      v-if="cooperateStatusLogDialog.visible"
      :visible.sync="cooperateStatusLogDialog.visible"
      :uuid="cooperateStatusLogDialog.uuid"
      :status-type="cooperateStatusLogDialog.statusType"
      :status-type-desc="cooperateStatusLogDialog.statusTypeDesc"
    />
    <!-- 重新分润 -->
    <profit-share-dialog
      v-if="profitShareDialog.visible"
      :visible.sync="profitShareDialog.visible"
      :job-uuid="this.jobUuid"
      :job="this.job"
      :init-share-amount="initShareAmount"
      :share-branch-list="shareBranchList"
      @confirm="profitShareConfirmHandler"
    />
    <!-- 分润调整 -->
    <profit-share-adjust-dialog
      v-if="profitShareAdjustDialog.visible"
      :visible.sync="profitShareAdjustDialog.visible"
      :job-uuid="this.jobUuid"
      :job="this.job"
      :share-amount="shareAmount"
      :share-amounts="shareAmounts"
      :init-share-amount="initShareAmount"
      :share-branch-list="shareBranchList"
      @confirm="profitShareConfirmHandler"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cooperationBranchDialog from '@/components/Cargo/Job/cooperationBranchDialog'
import cooperateStatusDialog from '@/components/Cargo/Job/cooperateStatusDialog'
import cooperateStatusLogDialog from '@/components/Cargo/Job/cooperateStatusLogDialog'
import profitShareDialog from '@/components/Cargo/Job/profitShareDialog'
import profitShareAdjustDialog from '@/components/Cargo/Job/profitShareAdjustDialog'
import { query, save, remove, updateState, queryProfitShare, generateProfitShare } from '@/api/booking/jobCooperate'
import { getUuid } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'CooperationBranchList',
  components: { cooperationBranchDialog, cooperateStatusDialog, cooperateStatusLogDialog, profitShareDialog, profitShareAdjustDialog },
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true },
    job: { type: Object, required: true },
    orderCenterBranch: { type: Boolean, default: false }, // 是否接单分公司
    showCooperateAll: { type: Boolean, default: false } // 查看更多协作信息
  },
  data() {
    return {
      commandCode: this.$t('CargoMsg.Cargo_LogRecord'),
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          resizable: true,
          filter: true
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.editHandler
      },
      gridParams: {},
      columnDefs: [
        { headerName: '', checkboxSelection: true, width: 50, sortable: false, suppressMenu: true,
          suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_EntrustBranchId'), field: 'entrustBranchId', minWidth: 120, width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'), field: 'branchId', minWidth: 120, width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'), field: 'businessType', minWidth: 150, width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.businessTypeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Operation'), field: 'opId', minWidth: 80, width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerService'), field: 'csrId', minWidth: 80, width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_CustomerServiceOverSea'), field: 'overseaOp', minWidth: 100, width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'dcId', minWidth: 80, width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_AirlinePerson'), field: 'planner', minWidth: 110, width: 110,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ReviewTime'), field: 'cooperateStatusDate', minWidth: 130, width: 130,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_CooperateStatus'), field: 'cooperateStatus', minWidth: 100, width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.cooperateStatusLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessStatus'), field: 'businessStatus', minWidth: 100, width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.businessStatusLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ChargeStatus'), field: 'chargeStatus', minWidth: 100, width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.businessStatusLabelFunc(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessStatusRemark'), field: 'businessRemark', minWidth: 130, width: 130 },
        { headerName: this.$t('CargoMsg.Cargo_ChargeStatusRemark'), field: 'chargeRemark', minWidth: 130, width: 130 },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', minWidth: 130, width: 130 },
        { headerName: this.$t('CargoMsg.Cargo_ProfitShareColumn'), field: 'profitShare', minWidth: 100, width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          cellStyle: { textAlign: 'center' }
        }
      ],
      rowData: [],
      changeFlag: false,
      selectedItem: null, // 表格选中项
      cooperationBranchDialog: {
        visible: false,
        jobUuid: this.jobUuid,
        cooperate: null,
        submitCallBack: this.toSubmitCallBack,
        editable: true,
        actionDesc: ''
      },
      cooperateStatusDialog: {
        visible: false,
        statusTypeDesc: '',
        updateStateCallBack: this.toUpdateStateCallBack
      },
      cooperateStatusLogDialog: {
        visible: false,
        uuid: '',
        statusType: 0,
        statusTypeDesc: ''
      },
      // 分润记录
      shareAmounts: [],
      shareAmount: {
        jobUuid: '',
        branchId: 0,
        shareMode: SystemConstants.SHARE_MODE_JOB.code,
        usdProfit: 0,
        nonUsdProfit: 0,
        jobProfit: 0,
        currency: '',
        apMaxSerialNumber: 1,
        officeId: 0,
        usdRate: 0
      },
      // 参与分润分公司
      shareBranchList: [],
      // 最新分润金额
      initShareAmount: {
      },
      // 重新分润
      profitShareDialog: {
        visible: false
      },
      // 分润调整
      profitShareAdjustDialog: {
        visible: false
      },
      hasOpOfficeCooperate: this.$checkPermission(['button_Job_opOfficeCooperate']) // 有操作公司协作管理权限
    }
  },
  computed: {
    title() {
      return this.showCooperateAll ? this.$t('CargoMsg.Cargo_ShowCooperateAll') : this.$t('CargoMsg.Cargo_SelectCooperateBranch')
    },
    controlConfirmButton() {
      return !this.showCooperateAll && this.orderCenterBranch
    }
  },
  watch: {
    jobUuid: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.changeFlag = true
      }
    }
  },
  mounted() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = getLoading()
      query({ jobUuid: this.jobUuid, branchId: (this.orderCenterBranch || this.hasOpOfficeCooperate) ? 0 : this.$store.getters.currentOffice.officeId }).then(res => {
        this.rowData = res.data
        for (const row of this.rowData) {
          if (!row.businessType) row.businessType = row.businessType
        }
      }).finally(() => {
        this.loading.close()
      })
      if (this.gridOptions.api) this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
    },
    // 刷新
    refreshHandler() {
      this.loadList()
    },
    // 确定
    onOK() {
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      this.loading = getLoading()
      save(this.rowData).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_CooperateSucceed'))
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.gridOptions.api) this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
      this.refresh()
    },
    // 取消
    onCancel() {
      this.$emit('cancel', '')
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(params) {
      if (params.api.getFocusedCell() !== null && params.api.getFocusedCell().rowIndex !== undefined) {
        const rowIndex = params.api.getFocusedCell().rowIndex
        const cell = params.api.rowModel.rowsToDisplay[rowIndex]
        const event = {}
        event.data = cell.data
        this.onRowClicked(event)
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    showDialog() {
      if (this.changeFlag) {
        this.changeFlag = false
        this.refreshHandler()
      }
    },
    initForm() {
      return {
        uuid: '',
        branchId: 0,
        businessType: [],
        opId: 0,
        opDepartment: 0,
        csrId: 0,
        overseaOp: 0,
        dcId: 0,
        planner: 0,
        remark: '',
        sales: 0,
        salesOffice: 0,
        salesDepartment: 0,
        cargoSalesId: 0,
        cargoSalesDepartment: 0,
        cargoSalesOffice: 0,
        userDefinedRoleId1: 0,
        userDefinedRoleDept1: 0,
        userDefinedRoleOffice1: 0,
        userDefinedRoleId2: 0,
        userDefinedRoleDept2: 0,
        userDefinedRoleOffice2: 0,
        entrustBranchId: 0, // 委托分公司
        cooperateStatus: 0, // 协作状态
        businessStatus: 0, // 业务状态
        chargeStatus: 0, // 费用状态
        profitShare: true // 是否参与分润
      }
    },
    // 新增
    addHandler() {
      const currentRow = this.initForm()
      currentRow.index = getUuid()
      currentRow.rowIndex = this.rowData ? this.rowData.length : 0
      currentRow.jobUuid = this.jobUuid
      currentRow.entrustBranchId = this.$store.getters.currentOfficeId
      this.cooperationBranchDialog.cooperate = currentRow
      this.cooperationBranchDialog.editable = currentRow.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code
      this.cooperationBranchDialog.actionDesc = this.$t('CargoMsg.Cargo_Add')
      this.cooperationBranchDialog.visible = true
    },
    // 编辑
    editHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      if (!cell || !this.selectedItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.selectedItem.index = this.selectedItem.index ? this.selectedItem.index : this.selectedItem.uuid
      const currentRow = {}
      Object.assign(currentRow, this.selectedItem)
      currentRow.businessType = currentRow.businessType ? currentRow.businessType.split(',') : []
      this.cooperationBranchDialog.cooperate = currentRow
      this.cooperationBranchDialog.editable = this.orderCenterBranch && currentRow.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code
      if (this.cooperationBranchDialog.editable) {
        this.cooperationBranchDialog.actionDesc = this.$t('CargoMsg.Cargo_Edit')
      } else {
        this.cooperationBranchDialog.actionDesc = this.$t('CargoMsg.Cargo_View')
      }
      this.cooperationBranchDialog.visible = true
    },
    toSubmitCallBack(result) {
      result.businessType = result.businessType.toString()
      let isAdded = false
      for (const row of this.rowData) {
        if (row.index === result.index) {
          row.branchId = result.branchId
          row.businessType = result.businessType
          row.opId = result.opId
          row.opDepartment = result.opDepartment
          row.csrId = result.csrId
          row.overseaOp = result.overseaOp
          row.dcId = result.dcId
          row.planner = result.planner
          row.remark = result.remark
          row.entrustBranchId = result.entrustBranchId
          row.sales = result.sales
          row.salesOffice = result.salesOffice
          row.salesDepartment = result.salesDepartment
          row.cargoSalesId = result.cargoSalesId
          row.cargoSalesDepartment = result.cargoSalesDepartment
          row.cargoSalesOffice = result.cargoSalesOffice
          row.userDefinedRoleId1 = result.userDefinedRoleId1
          row.userDefinedRoleDept1 = result.userDefinedRoleDept1
          row.userDefinedRoleOffice1 = result.userDefinedRoleOffice1
          row.userDefinedRoleId2 = result.userDefinedRoleId2
          row.userDefinedRoleDept2 = result.userDefinedRoleDept2
          row.userDefinedRoleOffice2 = result.userDefinedRoleOffice2
          row.profitShare = result.profitShare
          isAdded = true
          break
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
      if (!isAdded) { // 新增
        this.rowData.push(result)
        this.$nextTick(() => {
          this.gridOptions.api.setFocusedCell(result.rowIndex, 'branchId')
        })
      }
    },
    // 删除
    deleteHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!this.checkDeleteable(rows)) return
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureDelete'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toDelete(rows)
      }).catch(() => {
        //
      })
    },
    // 校验能否删除
    checkDeleteable(rows) {
      for (const row of rows) {
        if (row.branchId === this.job.opOffice) continue
        if (row.cooperateStatus === SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CooperateStatusApprovedCanTBeDeleted'))
          return false
        }
      }
      return true
    },
    toDelete(rows) {
      const keys = []
      rows.forEach(row => { if (row.uuid) keys.push(row.uuid) })
      if (keys.length === 0) { // 没有uuid
        this.deleteResultHandler(rows)
      } else {
        this.loading = getLoading()
        remove({ 'uuids': keys }).then(res => {
          if (res.data) this.deleteResultHandler(rows)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    deleteResultHandler(rows) {
      this.gridOptions.api.updateRowData({ remove: rows })
      const rowList = this.rowData
      // 移除
      for (const row of rows) {
        rowList.forEach(function(item, index, arr) {
          if ((row.uuid && row.uuid === item.uuid) || (!row.uuid && row.index === item.index)) {
            arr.splice(index, 1)
          }
        })
      }
      this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
      if (this.gridOptions.api) this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
      this.refresh()
    },
    // 更新业务/费用状态：1、cooperate:协作状态 2、business:业务状态 3、charge:费用状态
    updateStateHandler(statusType) {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const keys = []
      for (const row of rows) {
        if (!row.uuid || row.branchId !== this.job.opOffice) continue
        keys.push(row.uuid)
      }
      if (keys.length === 0) return
      //
      if (statusType === SystemConstants.STATUSTYPE_BUSINESS.code) {
        this.cooperateStatusDialog.statusTypeDesc = this.$t('CargoMsg.Cargo_BusinessStatus')
      } else if (statusType === SystemConstants.STATUSTYPE_CHARGE.code) {
        this.cooperateStatusDialog.statusTypeDesc = this.$t('CargoMsg.Cargo_ChargeStatus')
      }
      this.cooperateStatusDialog.statusType = statusType
      this.cooperateStatusDialog.keys = keys
      this.cooperateStatusDialog.visible = true
    },
    toUpdateStateCallBack(result) {
      result.uuids = this.cooperateStatusDialog.keys
      result.statusType = this.cooperateStatusDialog.statusType
      this.loading = getLoading()
      updateState(result).then(res => {
        // 刷新
        if (res.data) {
          for (const item of res.data) {
            for (const row of this.rowData) {
              if (item.uuid === row.uuid) {
                if (result.statusType === SystemConstants.STATUSTYPE_BUSINESS.code) {
                  row.businessStatus = item.businessStatus
                  row.businessStatusDate = item.businessStatusDate
                  row.businessStatusBy = item.businessStatusBy
                  row.businessRemark = item.businessRemark
                } else if (result.statusType === SystemConstants.STATUSTYPE_CHARGE.code) {
                  row.chargeStatus = item.chargeStatus
                  row.chargeStatusDate = item.chargeStatusDate
                  row.chargeStatusBy = item.chargeStatusBy
                  row.chargeRemark = item.chargeRemark
                }
              }
            }
          }
          this.gridOptions.api.refreshCells({ force: true })
        }
        this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 日志记录
    btnStatusLogHandler() {
      if (this.commandCode === this.$t('CargoMsg.Cargo_CooperateStatusLog')) {
        this.showStatusLog(SystemConstants.STATUSTYPE_COOPERATE.code)
      } else if (this.commandCode === this.$t('CargoMsg.Cargo_BusinessStatusLog')) {
        this.showStatusLog(SystemConstants.STATUSTYPE_BUSINESS.code)
      } else if (this.commandCode === this.$t('CargoMsg.Cargo_ChargeStatusLog')) {
        this.showStatusLog(SystemConstants.STATUSTYPE_CHARGE.code)
      }
    },
    showStatusLog(statusType) {
      console.log('showStatusLog', statusType)
      const cell = this.gridOptions.api.getFocusedCell()
      if (!cell || !this.selectedItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.cooperateStatusLogDialog.uuid = this.selectedItem.uuid
      this.cooperateStatusLogDialog.statusType = statusType
      if (statusType === SystemConstants.STATUSTYPE_COOPERATE.code) {
        this.cooperateStatusLogDialog.statusTypeDesc = this.$t('CargoMsg.Cargo_CooperateStatusLog')
      } else if (statusType === SystemConstants.STATUSTYPE_BUSINESS.code) {
        this.cooperateStatusLogDialog.statusTypeDesc = this.$t('CargoMsg.Cargo_BusinessStatusLog')
      } else if (statusType === SystemConstants.STATUSTYPE_CHARGE.code) {
        this.cooperateStatusLogDialog.statusTypeDesc = this.$t('CargoMsg.Cargo_ChargeStatusLog')
      }
      this.cooperateStatusLogDialog.visible = true
    },
    // 刷新
    refresh() {
      let cooperatebranch = ''
      this.rowData.forEach(row => { cooperatebranch += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', row.branchId, 'chineseName') + ',' })
      this.$emit('refresh', cooperatebranch)
    },
    // 分润调整
    profitShareAdjustHandler() {
      // 参与分润分公司
      this.shareBranchList = []
      let serialNo = 1
      for (const item of this.rowData) {
        if (item.profitShare) {
          this.shareBranchList.push({
            jobUuid: this.jobUuid,
            branchId: item.branchId,
            serialNo: serialNo,
            usdRatio: 0,
            nonUsdRatio: 0,
            usdProfit: 0,
            nonUsdProfit: 0
          })
          serialNo++
        }
      }
      if (this.shareBranchList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonProfitShareBranch'))
        return
      }
      this.loading = getLoading()
      queryProfitShare([this.jobUuid]).then(res => {
        if (res.data) {
          this.initShareAmount = res.data.initShareAmount
          this.initShareAmount.shareMode = SystemConstants.SHARE_MODE_CURRENCY.code
          this.shareAmounts = res.data.shareAmounts || []
          this.shareCharges = res.data.shareCharges || []
          let showDailog = true
          // 是否重新分润
          let flag = this.shareAmounts.length === 0
          if (!flag) {
            this.shareAmount = this.shareAmounts[0]
            // 已分润合计
            let usdProfitSum = 0
            let nonUsdProfitSum = 0
            let jobProfitSum = 0
            const batchNos = []
            for (const item of this.shareAmounts) {
              const batchNo = ColumnUtils.dateTimeLabelFunc(item.dateCreated)
              if (batchNos.indexOf(batchNo) !== -1) {
                continue
              }
              batchNos.push(batchNo)
              usdProfitSum += NumberUtils.ToFixed(item.usdProfit, 2)
              nonUsdProfitSum += NumberUtils.ToFixed(item.nonUsdProfit, 2)
              jobProfitSum += NumberUtils.ToFixed(item.jobProfit, 2)
              usdProfitSum = NumberUtils.ToFixed(usdProfitSum, 2)
              nonUsdProfitSum = NumberUtils.ToFixed(nonUsdProfitSum, 2)
              jobProfitSum = NumberUtils.ToFixed(jobProfitSum, 2)
            }
            this.shareAmount.usdProfitSum = usdProfitSum
            this.shareAmount.nonUsdProfitSum = nonUsdProfitSum
            this.shareAmount.jobProfitSum = jobProfitSum
            if (this.shareAmount.usdProfitSum === this.initShareAmount.usdProfit &&
              this.shareAmount.nonUsdProfitSum === this.initShareAmount.nonUsdProfit &&
              this.shareAmount.jobProfitSum === this.initShareAmount.jobProfit) {
              for (const item of this.shareCharges) {
                if (item.billingUuid || item.invoiceUuid || item.billingPaymentUuid || item.verifiedAmount !== 0) {
                  const branchName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', item.branchId, 'chineseName')
                  this.$message.warning(this.$t('CargoMsg.Cargo_CheckProfitShareResetTip', [branchName]))
                  showDailog = false
                  break
                }
              }
              flag = true
              this.shareBranchList = []
              for (const item of this.shareAmounts) {
                if (!this.shareBranchList.find(re => re.branchId === item.branchId)) {
                  this.shareBranchList.push(item)
                }
              }
              // 序号
              if (this.shareBranchList.length !== this.shareAmounts.length) {
                let serialNo = 1
                for (const item of this.shareBranchList) {
                  item.serialNo = serialNo
                  serialNo++
                }
              }
              // this.shareBranchList = this.shareAmounts
              this.initShareAmount.shareMode = this.shareAmounts[0].shareMode
            }
          }
          if (showDailog) {
            if (flag) { // 重新分润
              this.profitShareDialog.visible = true
            } else { // 分润调整
              for (const item of this.shareCharges) {
                if (item.branchId === this.initShareAmount.officeId) {
                  this.initShareAmount.apMaxSerialNumber += 1 // 序号
                }
              }
              this.shareAmount = this.shareAmounts[0]
              const usdProfit = this.shareAmount.usdProfitSum || 0
              const nonUsdProfit = this.shareAmount.nonUsdProfitSum || 0
              const jobProfit = this.shareAmount.jobProfitSum || 0
              // 是否显示非美金
              const showNonUsdRatioInput = this.shareAmount.shareMode !== SystemConstants.SHARE_MODE_JOB.code
              // 变动利润
              const usdProfitAdjust = NumberUtils.ToFixed(this.initShareAmount.usdProfit - usdProfit, 2)
              const nonUsdProfitAdjust = NumberUtils.ToFixed(this.initShareAmount.nonUsdProfit - nonUsdProfit, 2)
              const jobProfitAdjust = NumberUtils.ToFixed(this.initShareAmount.jobProfit - jobProfit, 2)
              for (const item of this.shareAmounts) {
                item.usdProfitAdjust = usdProfitAdjust
                item.nonUsdProfitAdjust = nonUsdProfitAdjust
                item.jobProfitAdjust = jobProfitAdjust
                //
                item.usdRatio = item.usdRatio || 0
                const usdRatio = NumberUtils.ToFixed(item.usdRatio / 100, 2)
                item.usdProfitCol = NumberUtils.ToFixed((showNonUsdRatioInput ? item.usdProfit : item.jobProfit) * usdRatio, 2)
                item.usdProfitAdjustCol = NumberUtils.ToFixed((showNonUsdRatioInput ? usdProfitAdjust : jobProfitAdjust) * usdRatio, 2)
                // 非美金
                if (showNonUsdRatioInput) {
                  item.nonUsdRatio = item.nonUsdRatio || 0
                  const nonUsdRatio = NumberUtils.ToFixed(item.nonUsdRatio / 100, 2)
                  item.nonUsdProfitCol = NumberUtils.ToFixed(item.nonUsdProfit * nonUsdRatio, 2)
                  item.nonUsdProfitAdjustCol = NumberUtils.ToFixed(nonUsdProfitAdjust * nonUsdRatio, 2)
                } else {
                  item.nonUsdRatio = 0
                  item.nonUsdProfitCol = 0
                  item.nonUsdProfitAdjustCol = 0
                }
              }
              this.shareBranchList = []
              for (const item of this.shareAmounts) {
                if (!this.shareBranchList.find(re => re.branchId === item.branchId)) {
                  this.shareBranchList.push(item)
                }
              }
              // 序号
              if (this.shareBranchList.length !== this.shareAmounts.length) {
                let serialNo = 1
                for (const item of this.shareBranchList) {
                  item.serialNo = serialNo
                  serialNo++
                }
              }
              // this.shareBranchList = this.shareAmounts
              this.profitShareAdjustDialog.visible = true
            }
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    profitShareConfirmHandler(shareAmountList) {
      if (!shareAmountList || shareAmountList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonProfitShareBranch'))
        return
      }
      this.loading = getLoading()
      generateProfitShare(shareAmountList).then(res => {
        if (res.data) {
          this.profitShareDialog.visible = false
          this.profitShareAdjustDialog.visible = false
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.$emit('refreshJob')
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>
<style lang="scss">
.cooperate-branch-popup {
  .el-dialog__body {
    padding: 10px !important;
  }
}
</style>
